var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dateRangePicker-container"},[_c('label',[_c('i',{staticClass:"fa fa-calendar",class:{disabled: _vm.disabled}})]),_vm._v(" "),_c('input',{ref:"input",staticClass:"dateRangePicker-input form-control",attrs:{"dusk":"date-picker-input","type":"text","readonly":"readonly","disabled":_vm.disabled}})])
}
var staticRenderFns = []

export { render, staticRenderFns }